<mat-card class="price-annual-fee">
  <mat-card-header style="width: 100%;">
    <mat-card-title>{{ 'repository.annual-fee' | translate }}
    </mat-card-title>
    <mat-card-subtitle style="width: 100%;">
      <div style="width: 100%;display: flex; justify-content: space-between;">
        <div>
          {{ 'repository.annual-fee-subtitle' | translate }}
        </div>
        <div>
          <mat-slide-toggle [(ngModel)]="displayIndexesPrice" labelPosition="before">
            <span>{{ 'label.indexPrice' | translate }}</span>
          </mat-slide-toggle>
        </div>

      </div>
    </mat-card-subtitle>

  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.name' | translate }}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span> {{ element.name }}</span>
        </td>
      </ng-container>

      <!-- priceZoneA Column -->
      <ng-container matColumnDef="priceZoneA">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.priceZoneA' | translate }} (€/m²)</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="!displayIndexesPrice"> {{ element.priceZoneA | number :'0.6' :'fr'}}</span>
          <span *ngIf="displayIndexesPrice"> {{ element.indexPriceZoneA | number :'0.6' :'fr'}}</span>
        </td>
      </ng-container>

      <!-- name priceZoneB -->
      <ng-container matColumnDef="priceZoneB">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.priceZoneB' | translate }} (€/m²)</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="!displayIndexesPrice"> {{ element.priceZoneB | number :'0.6' :'fr'}}</span>
          <span *ngIf="displayIndexesPrice"> {{ element.indexPriceZoneB | number :'0.6' :'fr'}}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
        (click)="selectItemClick(row)"></tr>

    </table>
  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>

</mat-card>